// assets/cart-drawer.js
// Open/close drawer + Ajax cart updates (Shopify Cart API)

(function() {
  const drawer = document.querySelector('[data-cart-drawer]');
  const cartCount = document.querySelector('[data-cart-count]');
  const cartSubtotal = document.querySelector('[data-cart-subtotal]');
  const cartBody = document.querySelector('[data-cart-body]');

  function openDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-cart-toggle]');
    const close = e.target.closest('[data-cart-close]');
    if (toggle) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (close) {
      e.preventDefault();
      closeDrawer();
      return;
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer?.getAttribute('aria-hidden') === 'false') {
      closeDrawer();
    }
  });

  async function refreshCart() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    if (cartCount) cartCount.textContent = cart.item_count;
    const sectionRes = await fetch('/?section_id=cart-drawer');
    const html = await sectionRes.text();
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    const newBody = tmp.querySelector('[data-cart-body]');
    if (newBody && cartBody) cartBody.innerHTML = newBody.innerHTML;
    const foot = document.querySelector('[data-cart-foot]');
    const newFoot = tmp.querySelector('[data-cart-foot]');
    if (foot && newFoot) {
      foot.innerHTML = newFoot.innerHTML;
      foot.hidden = cart.item_count === 0;
    }
    const subtotal = document.querySelector('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    return cart;
  }

  function formatMoney(cents) {
    return 'R$ ' + (cents / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    const formData = new FormData(form);
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
      if (res.ok) {
        await refreshCart();
        openDrawer();
      } else {
        const err = await res.json();
        console.error('Cart add error', err);
      }
    } catch (e) {
      console.error(e);
    }
  });

  document.addEventListener('click', async (e) => {
    const item = e.target.closest('[data-cart-item]');
    if (!item) return;
    const key = item.dataset.lineKey;
    const display = item.querySelector('[data-qty-display]');
    let qty = parseInt(display?.textContent || '0', 10);

    if (e.target.closest('[data-qty-up]')) {
      qty += 1;
    } else if (e.target.closest('[data-qty-down]')) {
      qty = Math.max(0, qty - 1);
    } else if (e.target.closest('[data-cart-remove]')) {
      qty = 0;
    } else {
      return;
    }
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    await refreshCart();
  });

  // Quantity stepper no product page
  document.addEventListener('click', (e) => {
    const qtyContainer = e.target.closest('[data-qty]');
    if (!qtyContainer) return;
    const input = qtyContainer.querySelector('[data-qty-input]');
    if (!input) return;
    let v = parseInt(input.value || '1', 10);
    if (e.target.closest('[data-qty-up]')) v += 1;
    else if (e.target.closest('[data-qty-down]')) v = Math.max(1, v - 1);
    else return;
    input.value = v;
  });
})();
